export default __webpack_public_path__ + "static/media/430.adad8cff.svg";